import { z } from 'zod';

export const ApiConfigSchema = z.object({
  baseURL: z.url(),
  timeout: z.number().positive().default(10000),
  retryAttempts: z.number().int().positive().default(3),
  retryDelay: z.number().positive().default(1000),
  retryableStatuses: z.array(z.number()).default([408, 429, 500, 502, 503, 504]),
  retryableNetworkErrors: z
    .array(z.string())
    .default(['Failed to fetch', 'Network request failed']),
  endpoints: z.object({
    projects: z.string(),
    tasks: z.string(),
    subtasks: z.string(),
  }),
});

export type ApiConfig = z.infer<typeof ApiConfigSchema>;
